import { render, staticRenderFns } from "./confirm_order.vue?vue&type=template&id=dd143432"
import script from "./confirm_order.vue?vue&type=script&lang=js"
export * from "./confirm_order.vue?vue&type=script&lang=js"
import style0 from "./confirm_order.vue?vue&type=style&index=0&id=dd143432&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports